import React from 'react';

export const Input = ({ label, error, ...props }) => {
  return (
    <div style={{ marginBottom: '16px' }}>
      {label && <label className="input-label">{label}</label>}
      <input className="input-field" {...props} />
      {error && <span style={{ color: 'var(--danger)', fontSize: '12px', marginTop: '6px', display: 'block' }}>{error}</span>}
    </div>
  );
};
